import React from 'react'
import PropTypes from 'prop-types'
import { useDenaliActions } from '../provider/DenaliActionProvider'

function DenaliActionTrigger ({ code, subject, children }) {
  const { open } = useDenaliActions()

  return (
    <div onClick={() => open(code, subject)}>
      {children}
    </div>
  )
}

DenaliActionTrigger.propTypes = {
  code: PropTypes.string.isRequired,
  subject: PropTypes.string,
  children: PropTypes.node
}

export default DenaliActionTrigger
